import Skeleton from 'react-loading-skeleton';

import {
    SkeletonHeaderWrapper,
    SkeletonImageWrapper,
    SkeletonTitleWrapper,
} from './HeaderSkeleton.styled';

export const HeaderSkeleton = () => {
    return (
        <SkeletonHeaderWrapper>
            <SkeletonTitleWrapper>
                <Skeleton height={20} width={`100%`} />
            </SkeletonTitleWrapper>
            <SkeletonImageWrapper>
                <Skeleton height={40} key={'image'} width={`100%`} />
            </SkeletonImageWrapper>
        </SkeletonHeaderWrapper>
    );
};
